import {
    IntegratedCompliancePropertyStatus,
    ServiceExclusivity,
    StateShortName,
} from '@acp/shared';
import { ServiceExclusivityOption, ServiceOption } from './types';

const defaultServiceExclusivityOptions: ServiceExclusivityOption[] = [
    {
        label: 'Includes selected',
        value: ServiceExclusivity.Including,
        description: 'Properties that are on any of the services selected',
    },
    {
        label: 'Only selected',
        value: ServiceExclusivity.Only,
        description: 'Properties that are on all of the services selected',
    },
    {
        label: 'Excludes selected',
        value: ServiceExclusivity.Excluding,
        description: 'Properties that are not on any of the services selected',
    },
];

const defaultServiceOptions: ServiceOption[] = [
    {
        label: 'Smoke Alarms',
        value: 'smoke',
        applicableStates: null,
    },
    {
        label: 'Electrical',
        value: 'electrical',
        applicableStates: [StateShortName.VIC],
    },
    {
        label: 'Gas',
        value: 'gas',
        applicableStates: [StateShortName.VIC],
    },
    {
        label: 'Corded Blinds',
        value: 'cordedblinds',
        applicableStates: null,
    },
    {
        label: 'Water Efficiency',
        value: 'water',
        applicableStates: null,
    },
    {
        label: 'Safety Switches',
        value: 'rcd',
        applicableStates: null,
    },
    {
        label: 'Minimum Standards',
        value: 'minimum',
        applicableStates: null,
    },
];

const integratedServiceOptions: ServiceOption[] = [
    {
        label: 'Smoke Alarms',
        value: 'smoke',
        applicableStates: null,
    },
    {
        label: 'Electrical',
        value: 'electrical',
        applicableStates: [StateShortName.VIC],
    },
    {
        label: 'Gas',
        value: 'gas',
        applicableStates: [StateShortName.VIC],
    },
];

const integratedServiceComplianceStatusOptions: {
    label: string;
    value: IntegratedCompliancePropertyStatus | null;
}[] = [
    {
        label: 'Any compliance status',
        value: null,
    },
    {
        label: 'Compliant*',
        value: IntegratedCompliancePropertyStatus.Compliant,
    },
    {
        label: 'Compliance issues*',
        value: IntegratedCompliancePropertyStatus.ComplianceIssues,
    },
];

export {
    defaultServiceExclusivityOptions,
    defaultServiceOptions,
    integratedServiceOptions,
    integratedServiceComplianceStatusOptions,
};
